import { format } from './format'
import { formatDateRange } from './formatDateRange'
import { formatDestinationDate } from './formatDestinationDate'
import { formatDestinationDateRange } from './formatDestinationDateRange'
import { formatHour } from './formatHour'

export * from './compareDates'
export const dateFormatter = { format, formatDateRange, formatDestinationDate, formatDestinationDateRange, formatHour }
